import { PopupBase, PopupType } from '../popup';

export class InfoPopupModel implements PopupBase {
    public type = PopupType.Info;

    constructor(
        public id: string,
        public content: string,
        public buttonText: string = 'OK',
        public header?: string,
    ) {}
}
